import { createAppWrapper } from "@/common.js";
import PasswordNew from "@/users/passwords/New.vue";

document.addEventListener("DOMContentLoaded", () => {
  createAppWrapper(PasswordNew);
});
